import { COLOR_GREY_200, COLOR_GREY_600, COLOR_TEXT_GREY } from 'src/utils/colors';
import { COLOR_PRIMARY } from 'src/utils/const';

const SLIDER_TRACK_DIMENSION = '5px';
const SLIDER_THUMB_DIMENSION = '20px';

export const reportPageStyles = {
  paper: {
    background: '#FFF',
    boxShadow: '0px 4px 40px -20px rgba(0, 0, 0, 0.25)',
    borderRadius: '20px',
    padding: '20px',
  },
  actionSectionButton: {
    width: '120px',
    background: COLOR_PRIMARY,
    color: '#fff',
    fontSize: '16px',
    borderRadius: '8px',
    padding: '8px 16px',
    marginRight: '10px',
    transition: 'background 0.3s ease',
    '&:hover': {
      background: '#222',
    },
  },
  reportInputSection: {
    position: 'relative',
    overflow: 'hidden',
    margin: 0,
    marginTop: '20px',
    height: '310px',
    '&::before': {
      content: "''",
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '10px',
      background: COLOR_PRIMARY,
    },
  },
  reportKPISection: {
    // position: 'relative',
    overflow: 'hidden',
    marginTop: '20px',
    padding: '30px',
  },
  reportInputSectionChipStyle: (color: string = '#000', hover: boolean = true) => ({
    color: color,
    fontSize: '18px',
    fontWeight: 500,
    cursor: hover ? 'pointer' : 'default',
    textTransform: 'capitalize',
    transition: 'background 0.25s ease',
    ...(hover
      ? {
          '&:hover': {
            color: '#fff',
            background: COLOR_PRIMARY + '!important',
          },
        }
      : {}),
  }),
  reportInputSectionSubInput: {
    textDecoder: 'none',
    cursor: 'pointer',
    textDecoration: 'underline',
    textTransform: 'capitalize',
  },
  modalCenter: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  filterModalBodyRoot: {
    position: 'relative',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'clamp(300px, 70vw, 700px)',
    bgcolor: 'background.paper',
    border: 'none',
    outline: 'none',
    boxShadow: 24,
    p: 4,
    borderRadius: '20px',
    maxHeight: '94vh',
    overflowY: 'auto',
  },
  filterModalCloseIcon: {
    position: 'absolute',
    top: '5px',
    right: '5px',
    cursor: 'pointer',
  },
  toggleListModalCloseIcon: {
    position: 'absolute',
    top: '25px',
    right: '30px',
    cursor: 'pointer',
  },
  filterGroupHeadingTextColor: {
    color: COLOR_TEXT_GREY,
    fontWeight: 500,
    fontSize: '18px',
  },
  filterChipStyle: (selected: boolean = false, color: string = '#000') => ({
    fontSize: '16px',
    fontWeight: 400,
    cursor: 'pointer',
    textTransform: 'capitalize',
    transition: 'background 0.25s ease',
    border: `2px solid ${COLOR_PRIMARY}`,
    background: selected ? COLOR_PRIMARY : '#fff',
    color: selected ? '#fff' : color,
    '&:hover': {
      color: '#fff',
      background: COLOR_PRIMARY + '!important',
    },
  }),
  bedroomCounterContainer: {
    marginLeft: '16px',
    marginTop: '20px',
  },
  bedroomCounterButton: {
    border: '1px solid #000',
    height: '24px',
    width: '24px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  filterHeading: {
    fontSize: '24px',
    color: '#000',
    fontWeight: 400,
    mb: '20px',
  },
  slider: {
    '& .MuiSlider-rail': {
      opacity: 1,
      backgroundColor: COLOR_GREY_200,
      height: SLIDER_TRACK_DIMENSION,
    },
    '& .MuiSlider-track': {
      height: SLIDER_TRACK_DIMENSION,
    },
    '& .MuiSlider-thumb': {
      height: SLIDER_THUMB_DIMENSION,
      width: SLIDER_THUMB_DIMENSION,
      backgroundColor: 'white',
      border: '2px solid currentColor',
    },
    '& .MuiSlider-mark': {
      width: SLIDER_TRACK_DIMENSION,
      height: SLIDER_TRACK_DIMENSION,
      backgroundColor: COLOR_GREY_600,
      borderRadius: SLIDER_TRACK_DIMENSION,
    },
    '& .MuiSlider-markActive': {
      backgroundColor: 'white',
    },
  },
};
